import React, { useContext } from 'react';
import LockContext from 'contexts/lock_ressource/context';

export const useLock = () => {
  const context = useContext(LockContext);

  if (!context) {
    throw new Error('useLock doit être utilisé dans un LockProvider');
  }

  return context;
};
